import { FaHistory } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { MdMeetingRoom, MdUpcoming } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";
import { FaCog } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useEvent } from "../../../context/EventContext";

// Sidebar component renders a sidebar for the User Dashboard page.
// It renders a series of links to different sections of the page and highlights the active section.
// The component also renders a progress bar showing the percentage of the main event form filled.
// The active section is highlighted in the sidebar.
const Sidebar = () => {
  const [activeSection, setActiveSection] = useState("");
  const { logout } = useAuth();
  const { profileFormFilledPercentage } = useEvent();

  //   * Handles the click event of the sidebar item.
  //   * It sets the activeSection state to the clicked section.
  const handleActive = (section) => {
    setActiveSection(section);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="sidebar">
      <div
        className={`section ${activeSection === "profile" ? "active" : ""}`}
        onClick={() => handleActive("profile")}
      >
        <FaUser className="icon" />
        <Link to="profile">
          Profile{" "}
          <span
            style={{
              color: "#00FF00",
              fontWeight: "bold",
            }}
          >
            {profileFormFilledPercentage} %{" "}
          </span>
        </Link>
      </div>
      <div
        className={`section ${activeSection === "past-events" ? "active" : ""}`}
        onClick={() => handleActive("past-events")}
      >
        <FaHistory className="icon" />
        <Link to="past-events">Past Events</Link>
      </div>
      <div
        className={`section ${activeSection === "connections" ? "active" : ""}`}
        onClick={() => handleActive("connections")}
      >
        <FaUsers className="icon" />
        <Link to="connections">Connections</Link>
      </div>
      <div
        className={`section ${
          activeSection === "upcoming-events" ? "active" : ""
        }`}
        onClick={() => handleActive("upcoming-events")}
      >
        <MdUpcoming className="icon" />
        <Link to="upcoming-events">Upcoming Events</Link>
      </div>
      <div
        className={`section ${activeSection === "messages" ? "active" : ""}`}
        onClick={() => handleActive("messages")}
      >
        <FaEnvelope className="icon" />
        <Link to="messages">Messages</Link>
      </div>
      <div
        className={`section ${activeSection === "meetings" ? "active" : ""}`}
        onClick={() => handleActive("meetings")}
      >
        <MdMeetingRoom className="icon" />
        <Link to="meetings">Meetings</Link>
      </div>
      <div
        className={`section ${activeSection === "settings" ? "active" : ""}`}
        onClick={() => handleActive("settings")}
      >
        <FaCog className="icon" />
        <Link to="settings">Settings</Link>
      </div>
      <div
        className={`section ${activeSection === "logout" ? "active" : ""}`}
        onClick={() => handleLogout()}
      >
        <FaSignOutAlt className="icon" />
        <Link>Logout</Link>
      </div>
    </div>
  );
};

export default Sidebar;
